/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Cluster } from '../models';
// @ts-ignore
import type { ListClustersResponse } from '../models';
// @ts-ignore
import type { OmniAgentContext } from '../models';
// @ts-ignore
import type { OnboardClusterResponse } from '../models';
// @ts-ignore
import type { RegisteredCluster } from '../models';
// @ts-ignore
import type { RenderOmniAgentComponentResponse } from '../models';
// @ts-ignore
import type { ReportStatusRequest } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * ClustersAPIApi - axios parameter creator
 * @export
 */
export const ClustersAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes cluster from omni. The action indicates that cluster is offboarded from omni.
         * @summary Delete omni cluster
         * @param {string} organizationId The ID of the Organization.
         * @param {string} id The ID of the Cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clustersAPIDeleteCluster: async (organizationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('clustersAPIDeleteCluster', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('clustersAPIDeleteCluster', 'id', id)
            const localVarPath = `/omni-provisioner/v1beta/organizations/{organizationId}/clusters/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Method to get Omni cluster details.
         * @summary Get cluster details
         * @param {string} organizationId The ID of the Organization.
         * @param {string} id The ID of the Cluster.
         * @param {boolean} [includeEdgeLocations] Whether edge locations should be included in the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clustersAPIGetCluster: async (organizationId: string, id: string, includeEdgeLocations?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('clustersAPIGetCluster', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('clustersAPIGetCluster', 'id', id)
            const localVarPath = `/omni-provisioner/v1beta/organizations/{organizationId}/clusters/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeEdgeLocations !== undefined) {
                localVarQueryParameter['includeEdgeLocations'] = includeEdgeLocations;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Method to list clusters in omni provider.
         * @summary List clusters in omni provider
         * @param {string} organizationId The ID of the Organization.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {boolean} [includeEdgeLocations] Whether edge locations should be included in the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clustersAPIListClusters: async (organizationId: string, pageLimit?: string, pageCursor?: string, includeEdgeLocations?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('clustersAPIListClusters', 'organizationId', organizationId)
            const localVarPath = `/omni-provisioner/v1beta/organizations/{organizationId}/clusters`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (includeEdgeLocations !== undefined) {
                localVarQueryParameter['includeEdgeLocations'] = includeEdgeLocations;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Method to onboard command to onboard the cluster.
         * @summary Onboard cluster to omni provider by installing components
         * @param {string} organizationId The ID of the Organization.
         * @param {string} id The ID of the cluster to be onboarded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clustersAPIOnboardCluster: async (organizationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('clustersAPIOnboardCluster', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('clustersAPIOnboardCluster', 'id', id)
            const localVarPath = `/omni-provisioner/v1beta/organizations/{organizationId}/clusters/{id}:onboard`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Method to return the script to onboard the cluster.
         * @summary Get onboarding script
         * @param {string} organizationId The ID of the Organization.
         * @param {string} id The ID of the cluster to be onboarded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clustersAPIOnboardClusterScript: async (organizationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('clustersAPIOnboardClusterScript', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('clustersAPIOnboardClusterScript', 'id', id)
            const localVarPath = `/omni-provisioner/v1beta/organizations/{organizationId}/clusters/{id}:onboardScript`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Registers cluster as onboarded to omni provider.
         * @summary Registers cluster as onboarded to omni provider
         * @param {string} organizationId The ID of the Organization.
         * @param {string} id The ID of the cluster to be registered.
         * @param {RegisteredCluster} registeredCluster 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clustersAPIRegisterCluster: async (organizationId: string, id: string, registeredCluster: RegisteredCluster, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('clustersAPIRegisterCluster', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('clustersAPIRegisterCluster', 'id', id)
            // verify required parameter 'registeredCluster' is not null or undefined
            assertParamExists('clustersAPIRegisterCluster', 'registeredCluster', registeredCluster)
            const localVarPath = `/omni-provisioner/v1beta/organizations/{organizationId}/clusters/{id}:register`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registeredCluster, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Renders the omni-agent component manifest.
         * @summary Render omni-agent component chart version and values overrides
         * @param {string} id The ID of the component. Only \&quot;omni-agent\&quot; is supported; other values  return NotFound.
         * @param {OmniAgentContext} omniAgentContext 
         * @param {string} [version] The requested omni-agent chart version. \&quot;latest\&quot; (or empty) resolves to the  latest version known to the API; otherwise must be an explicit chart  version or a full OCI chart reference (oci://...) to install the chart  directly from a registry.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clustersAPIRenderOmniAgentComponent: async (id: string, omniAgentContext: OmniAgentContext, version?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('clustersAPIRenderOmniAgentComponent', 'id', id)
            // verify required parameter 'omniAgentContext' is not null or undefined
            assertParamExists('clustersAPIRenderOmniAgentComponent', 'omniAgentContext', omniAgentContext)
            const localVarPath = `/castctl/v1beta/components/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(omniAgentContext, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Method to report status of the object.
         * @summary Report object status
         * @param {string} organizationId The ID of the Organization.
         * @param {string} id The ID of the cluster.
         * @param {ReportStatusRequest} reportStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clustersAPIReportStatus: async (organizationId: string, id: string, reportStatusRequest: ReportStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('clustersAPIReportStatus', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('clustersAPIReportStatus', 'id', id)
            // verify required parameter 'reportStatusRequest' is not null or undefined
            assertParamExists('clustersAPIReportStatus', 'reportStatusRequest', reportStatusRequest)
            const localVarPath = `/omni-provisioner/v2beta/organizations/{organizationId}/clusters/{id}:reportStatus`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClustersAPIApi - functional programming interface
 * @export
 */
export const ClustersAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClustersAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Deletes cluster from omni. The action indicates that cluster is offboarded from omni.
         * @summary Delete omni cluster
         * @param {string} organizationId The ID of the Organization.
         * @param {string} id The ID of the Cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clustersAPIDeleteCluster(organizationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clustersAPIDeleteCluster(organizationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClustersAPIApi.clustersAPIDeleteCluster']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Method to get Omni cluster details.
         * @summary Get cluster details
         * @param {string} organizationId The ID of the Organization.
         * @param {string} id The ID of the Cluster.
         * @param {boolean} [includeEdgeLocations] Whether edge locations should be included in the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clustersAPIGetCluster(organizationId: string, id: string, includeEdgeLocations?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Cluster>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clustersAPIGetCluster(organizationId, id, includeEdgeLocations, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClustersAPIApi.clustersAPIGetCluster']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Method to list clusters in omni provider.
         * @summary List clusters in omni provider
         * @param {string} organizationId The ID of the Organization.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {boolean} [includeEdgeLocations] Whether edge locations should be included in the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clustersAPIListClusters(organizationId: string, pageLimit?: string, pageCursor?: string, includeEdgeLocations?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListClustersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clustersAPIListClusters(organizationId, pageLimit, pageCursor, includeEdgeLocations, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClustersAPIApi.clustersAPIListClusters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Method to onboard command to onboard the cluster.
         * @summary Onboard cluster to omni provider by installing components
         * @param {string} organizationId The ID of the Organization.
         * @param {string} id The ID of the cluster to be onboarded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clustersAPIOnboardCluster(organizationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardClusterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clustersAPIOnboardCluster(organizationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClustersAPIApi.clustersAPIOnboardCluster']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Method to return the script to onboard the cluster.
         * @summary Get onboarding script
         * @param {string} organizationId The ID of the Organization.
         * @param {string} id The ID of the cluster to be onboarded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clustersAPIOnboardClusterScript(organizationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clustersAPIOnboardClusterScript(organizationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClustersAPIApi.clustersAPIOnboardClusterScript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Registers cluster as onboarded to omni provider.
         * @summary Registers cluster as onboarded to omni provider
         * @param {string} organizationId The ID of the Organization.
         * @param {string} id The ID of the cluster to be registered.
         * @param {RegisteredCluster} registeredCluster 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clustersAPIRegisterCluster(organizationId: string, id: string, registeredCluster: RegisteredCluster, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clustersAPIRegisterCluster(organizationId, id, registeredCluster, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClustersAPIApi.clustersAPIRegisterCluster']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Renders the omni-agent component manifest.
         * @summary Render omni-agent component chart version and values overrides
         * @param {string} id The ID of the component. Only \&quot;omni-agent\&quot; is supported; other values  return NotFound.
         * @param {OmniAgentContext} omniAgentContext 
         * @param {string} [version] The requested omni-agent chart version. \&quot;latest\&quot; (or empty) resolves to the  latest version known to the API; otherwise must be an explicit chart  version or a full OCI chart reference (oci://...) to install the chart  directly from a registry.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clustersAPIRenderOmniAgentComponent(id: string, omniAgentContext: OmniAgentContext, version?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RenderOmniAgentComponentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clustersAPIRenderOmniAgentComponent(id, omniAgentContext, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClustersAPIApi.clustersAPIRenderOmniAgentComponent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Method to report status of the object.
         * @summary Report object status
         * @param {string} organizationId The ID of the Organization.
         * @param {string} id The ID of the cluster.
         * @param {ReportStatusRequest} reportStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clustersAPIReportStatus(organizationId: string, id: string, reportStatusRequest: ReportStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clustersAPIReportStatus(organizationId, id, reportStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClustersAPIApi.clustersAPIReportStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClustersAPIApi - factory interface
 * @export
 */
export const ClustersAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClustersAPIApiFp(configuration)
    return {
        /**
         * Deletes cluster from omni. The action indicates that cluster is offboarded from omni.
         * @summary Delete omni cluster
         * @param {ClustersAPIApiClustersAPIDeleteClusterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clustersAPIDeleteCluster(requestParameters: ClustersAPIApiClustersAPIDeleteClusterRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.clustersAPIDeleteCluster(requestParameters.organizationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Method to get Omni cluster details.
         * @summary Get cluster details
         * @param {ClustersAPIApiClustersAPIGetClusterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clustersAPIGetCluster(requestParameters: ClustersAPIApiClustersAPIGetClusterRequest, options?: RawAxiosRequestConfig): AxiosPromise<Cluster> {
            return localVarFp.clustersAPIGetCluster(requestParameters.organizationId, requestParameters.id, requestParameters.includeEdgeLocations, options).then((request) => request(axios, basePath));
        },
        /**
         * Method to list clusters in omni provider.
         * @summary List clusters in omni provider
         * @param {ClustersAPIApiClustersAPIListClustersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clustersAPIListClusters(requestParameters: ClustersAPIApiClustersAPIListClustersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListClustersResponse> {
            return localVarFp.clustersAPIListClusters(requestParameters.organizationId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.includeEdgeLocations, options).then((request) => request(axios, basePath));
        },
        /**
         * Method to onboard command to onboard the cluster.
         * @summary Onboard cluster to omni provider by installing components
         * @param {ClustersAPIApiClustersAPIOnboardClusterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clustersAPIOnboardCluster(requestParameters: ClustersAPIApiClustersAPIOnboardClusterRequest, options?: RawAxiosRequestConfig): AxiosPromise<OnboardClusterResponse> {
            return localVarFp.clustersAPIOnboardCluster(requestParameters.organizationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Method to return the script to onboard the cluster.
         * @summary Get onboarding script
         * @param {ClustersAPIApiClustersAPIOnboardClusterScriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clustersAPIOnboardClusterScript(requestParameters: ClustersAPIApiClustersAPIOnboardClusterScriptRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.clustersAPIOnboardClusterScript(requestParameters.organizationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Registers cluster as onboarded to omni provider.
         * @summary Registers cluster as onboarded to omni provider
         * @param {ClustersAPIApiClustersAPIRegisterClusterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clustersAPIRegisterCluster(requestParameters: ClustersAPIApiClustersAPIRegisterClusterRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.clustersAPIRegisterCluster(requestParameters.organizationId, requestParameters.id, requestParameters.registeredCluster, options).then((request) => request(axios, basePath));
        },
        /**
         * Renders the omni-agent component manifest.
         * @summary Render omni-agent component chart version and values overrides
         * @param {ClustersAPIApiClustersAPIRenderOmniAgentComponentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clustersAPIRenderOmniAgentComponent(requestParameters: ClustersAPIApiClustersAPIRenderOmniAgentComponentRequest, options?: RawAxiosRequestConfig): AxiosPromise<RenderOmniAgentComponentResponse> {
            return localVarFp.clustersAPIRenderOmniAgentComponent(requestParameters.id, requestParameters.omniAgentContext, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * Method to report status of the object.
         * @summary Report object status
         * @param {ClustersAPIApiClustersAPIReportStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clustersAPIReportStatus(requestParameters: ClustersAPIApiClustersAPIReportStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.clustersAPIReportStatus(requestParameters.organizationId, requestParameters.id, requestParameters.reportStatusRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for clustersAPIDeleteCluster operation in ClustersAPIApi.
 * @export
 * @interface ClustersAPIApiClustersAPIDeleteClusterRequest
 */
export interface ClustersAPIApiClustersAPIDeleteClusterRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof ClustersAPIApiClustersAPIDeleteCluster
     */
    readonly organizationId: string

    /**
     * The ID of the Cluster.
     * @type {string}
     * @memberof ClustersAPIApiClustersAPIDeleteCluster
     */
    readonly id: string
}

/**
 * Request parameters for clustersAPIGetCluster operation in ClustersAPIApi.
 * @export
 * @interface ClustersAPIApiClustersAPIGetClusterRequest
 */
export interface ClustersAPIApiClustersAPIGetClusterRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof ClustersAPIApiClustersAPIGetCluster
     */
    readonly organizationId: string

    /**
     * The ID of the Cluster.
     * @type {string}
     * @memberof ClustersAPIApiClustersAPIGetCluster
     */
    readonly id: string

    /**
     * Whether edge locations should be included in the response.
     * @type {boolean}
     * @memberof ClustersAPIApiClustersAPIGetCluster
     */
    readonly includeEdgeLocations?: boolean
}

/**
 * Request parameters for clustersAPIListClusters operation in ClustersAPIApi.
 * @export
 * @interface ClustersAPIApiClustersAPIListClustersRequest
 */
export interface ClustersAPIApiClustersAPIListClustersRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof ClustersAPIApiClustersAPIListClusters
     */
    readonly organizationId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof ClustersAPIApiClustersAPIListClusters
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof ClustersAPIApiClustersAPIListClusters
     */
    readonly pageCursor?: string

    /**
     * Whether edge locations should be included in the response.
     * @type {boolean}
     * @memberof ClustersAPIApiClustersAPIListClusters
     */
    readonly includeEdgeLocations?: boolean
}

/**
 * Request parameters for clustersAPIOnboardCluster operation in ClustersAPIApi.
 * @export
 * @interface ClustersAPIApiClustersAPIOnboardClusterRequest
 */
export interface ClustersAPIApiClustersAPIOnboardClusterRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof ClustersAPIApiClustersAPIOnboardCluster
     */
    readonly organizationId: string

    /**
     * The ID of the cluster to be onboarded.
     * @type {string}
     * @memberof ClustersAPIApiClustersAPIOnboardCluster
     */
    readonly id: string
}

/**
 * Request parameters for clustersAPIOnboardClusterScript operation in ClustersAPIApi.
 * @export
 * @interface ClustersAPIApiClustersAPIOnboardClusterScriptRequest
 */
export interface ClustersAPIApiClustersAPIOnboardClusterScriptRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof ClustersAPIApiClustersAPIOnboardClusterScript
     */
    readonly organizationId: string

    /**
     * The ID of the cluster to be onboarded.
     * @type {string}
     * @memberof ClustersAPIApiClustersAPIOnboardClusterScript
     */
    readonly id: string
}

/**
 * Request parameters for clustersAPIRegisterCluster operation in ClustersAPIApi.
 * @export
 * @interface ClustersAPIApiClustersAPIRegisterClusterRequest
 */
export interface ClustersAPIApiClustersAPIRegisterClusterRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof ClustersAPIApiClustersAPIRegisterCluster
     */
    readonly organizationId: string

    /**
     * The ID of the cluster to be registered.
     * @type {string}
     * @memberof ClustersAPIApiClustersAPIRegisterCluster
     */
    readonly id: string

    /**
     * 
     * @type {RegisteredCluster}
     * @memberof ClustersAPIApiClustersAPIRegisterCluster
     */
    readonly registeredCluster: RegisteredCluster
}

/**
 * Request parameters for clustersAPIRenderOmniAgentComponent operation in ClustersAPIApi.
 * @export
 * @interface ClustersAPIApiClustersAPIRenderOmniAgentComponentRequest
 */
export interface ClustersAPIApiClustersAPIRenderOmniAgentComponentRequest {
    /**
     * The ID of the component. Only \&quot;omni-agent\&quot; is supported; other values  return NotFound.
     * @type {string}
     * @memberof ClustersAPIApiClustersAPIRenderOmniAgentComponent
     */
    readonly id: string

    /**
     * 
     * @type {OmniAgentContext}
     * @memberof ClustersAPIApiClustersAPIRenderOmniAgentComponent
     */
    readonly omniAgentContext: OmniAgentContext

    /**
     * The requested omni-agent chart version. \&quot;latest\&quot; (or empty) resolves to the  latest version known to the API; otherwise must be an explicit chart  version or a full OCI chart reference (oci://...) to install the chart  directly from a registry.
     * @type {string}
     * @memberof ClustersAPIApiClustersAPIRenderOmniAgentComponent
     */
    readonly version?: string
}

/**
 * Request parameters for clustersAPIReportStatus operation in ClustersAPIApi.
 * @export
 * @interface ClustersAPIApiClustersAPIReportStatusRequest
 */
export interface ClustersAPIApiClustersAPIReportStatusRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof ClustersAPIApiClustersAPIReportStatus
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof ClustersAPIApiClustersAPIReportStatus
     */
    readonly id: string

    /**
     * 
     * @type {ReportStatusRequest}
     * @memberof ClustersAPIApiClustersAPIReportStatus
     */
    readonly reportStatusRequest: ReportStatusRequest
}

/**
 * ClustersAPIApi - object-oriented interface
 * @export
 * @class ClustersAPIApi
 * @extends {BaseAPI}
 */
export class ClustersAPIApi extends BaseAPI {
    /**
     * Deletes cluster from omni. The action indicates that cluster is offboarded from omni.
     * @summary Delete omni cluster
     * @param {ClustersAPIApiClustersAPIDeleteClusterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClustersAPIApi
     */
    public clustersAPIDeleteCluster(requestParameters: ClustersAPIApiClustersAPIDeleteClusterRequest, options?: RawAxiosRequestConfig) {
        return ClustersAPIApiFp(this.configuration).clustersAPIDeleteCluster(requestParameters.organizationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Method to get Omni cluster details.
     * @summary Get cluster details
     * @param {ClustersAPIApiClustersAPIGetClusterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClustersAPIApi
     */
    public clustersAPIGetCluster(requestParameters: ClustersAPIApiClustersAPIGetClusterRequest, options?: RawAxiosRequestConfig) {
        return ClustersAPIApiFp(this.configuration).clustersAPIGetCluster(requestParameters.organizationId, requestParameters.id, requestParameters.includeEdgeLocations, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Method to list clusters in omni provider.
     * @summary List clusters in omni provider
     * @param {ClustersAPIApiClustersAPIListClustersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClustersAPIApi
     */
    public clustersAPIListClusters(requestParameters: ClustersAPIApiClustersAPIListClustersRequest, options?: RawAxiosRequestConfig) {
        return ClustersAPIApiFp(this.configuration).clustersAPIListClusters(requestParameters.organizationId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.includeEdgeLocations, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Method to onboard command to onboard the cluster.
     * @summary Onboard cluster to omni provider by installing components
     * @param {ClustersAPIApiClustersAPIOnboardClusterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClustersAPIApi
     */
    public clustersAPIOnboardCluster(requestParameters: ClustersAPIApiClustersAPIOnboardClusterRequest, options?: RawAxiosRequestConfig) {
        return ClustersAPIApiFp(this.configuration).clustersAPIOnboardCluster(requestParameters.organizationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Method to return the script to onboard the cluster.
     * @summary Get onboarding script
     * @param {ClustersAPIApiClustersAPIOnboardClusterScriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClustersAPIApi
     */
    public clustersAPIOnboardClusterScript(requestParameters: ClustersAPIApiClustersAPIOnboardClusterScriptRequest, options?: RawAxiosRequestConfig) {
        return ClustersAPIApiFp(this.configuration).clustersAPIOnboardClusterScript(requestParameters.organizationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Registers cluster as onboarded to omni provider.
     * @summary Registers cluster as onboarded to omni provider
     * @param {ClustersAPIApiClustersAPIRegisterClusterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClustersAPIApi
     */
    public clustersAPIRegisterCluster(requestParameters: ClustersAPIApiClustersAPIRegisterClusterRequest, options?: RawAxiosRequestConfig) {
        return ClustersAPIApiFp(this.configuration).clustersAPIRegisterCluster(requestParameters.organizationId, requestParameters.id, requestParameters.registeredCluster, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Renders the omni-agent component manifest.
     * @summary Render omni-agent component chart version and values overrides
     * @param {ClustersAPIApiClustersAPIRenderOmniAgentComponentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClustersAPIApi
     */
    public clustersAPIRenderOmniAgentComponent(requestParameters: ClustersAPIApiClustersAPIRenderOmniAgentComponentRequest, options?: RawAxiosRequestConfig) {
        return ClustersAPIApiFp(this.configuration).clustersAPIRenderOmniAgentComponent(requestParameters.id, requestParameters.omniAgentContext, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Method to report status of the object.
     * @summary Report object status
     * @param {ClustersAPIApiClustersAPIReportStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClustersAPIApi
     */
    public clustersAPIReportStatus(requestParameters: ClustersAPIApiClustersAPIReportStatusRequest, options?: RawAxiosRequestConfig) {
        return ClustersAPIApiFp(this.configuration).clustersAPIReportStatus(requestParameters.organizationId, requestParameters.id, requestParameters.reportStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

